/* eslint-disable react/jsx-one-expression-per-line */
import React, { createContext, useEffect, useCallback } from 'react';
import loadScript from 'utils/load-script';
import useStore from 'hooks/useStore';

export const globalContext = createContext();
const { Provider } = globalContext;

export default function GlobalProvider({ children, srcMap }) {
  const store = useStore({
    instaScript: false
  });
  const dispatch = useCallback(arg => store.dispatch(arg), [store.state]);

  useEffect(() => {
    const src = '//www.instagram.com/embed.js';
    if (store.state.instaScript) {
      loadScript(
        src,
        () =>
          dispatch({
            type: 'update',
            payload: {
              instaScriptReady: true
            }
          }),
        1000
      );
    }
  }, [store.state.instaScript]);

  useEffect(() => {
    dispatch({
      type: 'update',
      payload: {
        srcMap
      }
    });
  }, [srcMap]);

  return (
    <Provider value={{ state: store.state, dispatch }}>{children}</Provider>
  );
}
